export const agreementTypes = {
    GENERAL: 'General',
    REDUCTION_FEE: 'Reducción de cuota',
    INCREASE_FEE: 'Aumento de cuota',
    COURSE: 'Curso',
    INSURANCE: 'Seguro',
    COMMERCIAL_DISCOUNT: 'Descuento Comercial',
    OTHER: 'Otro'
};

export const feeAgreementsTypes = [
    //'GENERAL',
    'REDUCTION_FEE',
    'INCREASE_FEE',
    //'COURSE',
    //'INSURANCE',
    //'COMMERCIAL_DISCOUNT',
    //'OTHER'
];
